import qs from 'qs';

const getFilterContext = (statState, addedDateRange = {}) => {
	const { query: { currency }, filters: { selectedFilters } } = statState;

	if (selectedFilters.length === 0) return '';

	const initialFilterContext = {
		entity: {
			filters: [],
			currency,
			...addedDateRange
		},
		query: {
			filters: {},
			currency,
			...addedDateRange
		}
	};

	const filterContext = selectedFilters.reduce((acc, entity) => {

		acc.entity.filters.push({
			name: entity.name,
			values: entity.value,
			shouldInverse: entity.shouldInverse
		});

		acc.query.filters = {
			...acc.query.filters,
			[entity.name]: entity.value.map(val => val.value)
		};

		return acc;

	}, initialFilterContext);

	return qs.stringify(filterContext);
};

export default getFilterContext;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/shared/get-filters-context.js